import { BUSINESS } from "@/data/business";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-[#222222] bg-[#0D0D0D]">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="w-2.5 h-2.5 bg-[#FF3B30] block" />
          <span className="font-display font-bold text-white uppercase tracking-tight">
            Manasa Consumer Electronic Services
          </span>
        </div>
        <p className="font-mono-plex text-[#555555] text-xs uppercase tracking-[0.15em]">
          © {new Date().getFullYear()} — Repair & Installation, Hyderabad
        </p>
        <a
          href={`tel:${BUSINESS.phones[0].raw}`}
          data-testid="footer-call"
          className="font-mono-plex text-white text-xs uppercase tracking-[0.15em] hover:text-[#FF3B30] transition-colors"
        >
          {BUSINESS.phones[0].display}
        </a>
      </div>
    </footer>
  );
};

export default Footer;
